<div class="site-width bg-gray2">
  <div class="container-fluid pt-2 pt-md-3 pb-3 pb-md-4">
    <h2>{{ 'ecm.selector.rebound.title.' + universe | translate }}</h2>

    <ul class="items-list row">
      @for (link of 'ecm.selector.rebound.links' | translate; track link) {
        <li class="col-12 col-md-6">
          <ecm-mat-item-list
            [itemIcon]="link.icon"
            [itemLabel]="link.label"
            [itemPath]="getLink(link.link) | async"
            (materialItemListEvent)="openLink(link.link)"
          ></ecm-mat-item-list>
        </li>
      }
    </ul>
  </div>
</div>
